import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { IUserStoreState, useUserStore } from "../../../store/userState";
import { ISidebarState, useSidebarState } from "../../../store/sidebarState";
import { InviteMembers } from "./inviteMembers";
import { InviteTable } from "./invites";
import TabGenerator from "../TabGenerator";

const Members = () => {
  const [activeTab, setActiveTab] = useState("members");
  const { activePlan } = useUserStore() as IUserStoreState;
  const { fetchContext, context } = useSidebarState(
    (state) => state
  ) as ISidebarState;
  useEffect(() => {
    if (isEmpty(context)) {
      fetchContext();
    }
  }, [context]);
  const tabs = [
    {
      label: "Members",
      value: "members",
      component: <InviteMembers />,
    },
    {
      label: "Invites",
      value: "invites",
      component: <InviteTable />,
    },
  ];

  return <TabGenerator tabs={tabs} activeTab={activeTab} />;
};

export default withRouter(Members);
